import React, { useState, useEffect } from 'react'

import Alert from 'Components/Alert'

const HaloMigrationNotice = () => {
  const [formProps, setFormProps] = useState(null)

  useEffect(() => {
    fetch('/tickets/new.json')
      .then(response => response.json())
      .then(data => setFormProps(data))
  }, [])

  if (!formProps) return null

  const { clients, current_user: currentUser } = formProps
  const isClientMigratedToHalo = !currentUser?.calligo_employee
    && clients?.some(c => c.id === currentUser?.client?.id && c.migrated_to_halo)

  if (!isClientMigratedToHalo) return null

  return (
    <Alert alertType="warning" showAlert>
      <span>
        Please note that your company has now been migrated to the new service desk system.
        Viaje is available for historical ticket management only.
        Please logon to the new support portal at{' '}
        <a href="https://portal.calligo.io" target="_blank" rel="noopener noreferrer">
          https://portal.calligo.io
        </a>
        {' '}to raise any new tickets.
      </span>
    </Alert>
  )
}

export default HaloMigrationNotice
